import React, { useEffect, useState } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { change, Field, formValueSelector, isDirty, reset } from "redux-form"
import {
  CustomImageField,
  RadioField,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import PhonePreview from "./phonePreview"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import BottomNavigation from "components/BottomNavigation"
import { FONTS } from "constants/fonts"
import ColorPicker from "components/ColorPicker"

const HeaderTab = ({
  logoImage,
  handleSave,
  header_type,
  change,
  headerTitle,
  handleNext,
  handleBack,
  isDirty,
  resetForm,
  tabIsActive,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Row className="mt-3">
        <Col xl={8}>
          <Card>
            <CardHeader>
              <h4>Design the landing screen header</h4>
            </CardHeader>
            <CardBody>
              <Row>
                <Col xs="auto" className="my-2">
                  <Field
                    name="header_type"
                    type="radio"
                    component={RadioField}
                    value="1"
                    label="No header"
                    onChange={(event, newValue) => {
                      change("header.title", "")
                      change("header.logoImage", null)
                      change("header.deleteLogo", 1)
                    }}
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col xs="auto">
                  <Field
                    name="header_type"
                    type="radio"
                    component={RadioField}
                    value="2"
                    label="Create a header (optional)"
                  />
                </Col>
              </Row>
              <Row className="ms-4 mt-3">
                <Col
                  md={3}
                  xl={2}
                  className="mt-2"
                  style={{ minWidth: "fit-content" }}
                >
                  <label>Add header color:</label>
                </Col>
                <Col xs={"auto"}>
                  <Field
                    name="header_color"
                    component={ColorPicker}
                    disabled={header_type === "1"}
                  />
                </Col>
              </Row>
              <Row className="ms-4 mt-3">
                <Col
                  md={3}
                  xl={2}
                  className="mt-2"
                  style={{ minWidth: "fit-content" }}
                >
                  <label>Add image:</label>
                </Col>
                <Col xs={"auto"}>
                  <Field
                    name="logoImage"
                    component={CustomImageField}
                    disabled={header_type === "1" || headerTitle?.length > 0}
                    onChange={(event, newValue) => {
                      change("header.title", "")
                      change("header.deleteLogo", 1)
                    }}
                    onDelete={() => {
                      change("header.deleteLogo", 1)
                    }}
                  />
                </Col>
                <Col className="d-flex justify-content-end">
                  {logoImage && logoImage?.editedImage && (
                    <img
                      src={logoImage?.editedImage ? logoImage?.editedImage : ""}
                      alt="logoImage"
                      className="rounded avatar-xl"
                      style={{ blockSize: "auto" }}
                    />
                  )}
                </Col>
              </Row>
              <Row className="ms-4 mt-3">
                <Col
                  md={3}
                  xl={2}
                  className="mt-2"
                  style={{ minWidth: "fit-content" }}
                >
                  <label>Add text title:</label>
                </Col>
                <Col xs={"auto"}>
                  <Row>
                    <Field
                      name="title"
                      component={TextField}
                      placeholder="Text title"
                      disabled={
                        header_type === "1" ||
                        !!(logoImage && logoImage?.editedImage)
                      }
                    />
                  </Row>
                  <Row className="my-2">
                    <Field
                      name="font"
                      component={SingleSelectField}
                      options={FONTS.map(font => ({
                        value: font.value,
                        label: font.text,
                      }))}
                      placeholder="Select Font Family"
                      disabled={
                        header_type === "1" ||
                        !!(logoImage && logoImage?.editedImage)
                      }
                    />
                  </Row>
                  <Row>
                    <Field
                      name="font_color"
                      component={ColorPicker}
                      disabled={
                        header_type === "1" ||
                        !!(logoImage && logoImage?.editedImage)
                      }
                    />
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <BottomNavigation
            handleSave={handleSave}
            handleBack={handleBack}
            handleNext={handleNext}
          />
        </Col>
        <Col xl={4} className="mt-4 d-none d-xl-block">
          <PhonePreview />
        </Col>
      </Row>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.LANDING_SCREEN)

const mapStateToProps = state => ({
  logoImage: selector(state, "header.logoImage"),
  header_type: selector(state, "header.header_type"),
  headerTitle: selector(state, "header.title"),
  isDirty: isDirty(FORM_NAMES.LANDING_SCREEN)(state, ...["header"]),
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.LANDING_SCREEN, `${field}`, value)),
  resetForm: () => dispatch(reset(FORM_NAMES.LANDING_SCREEN)),
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderTab)
